const setSlides = (state, slides) => {
  state.presentation = {
    ...state.presentation,
    slides,
  }
}

export default {
  setSlides,
}
